<template>
  <div class="haed">
    <!-- <span class="tit">{{ tit }} </span> -->
    <div class="tit_box">{{ tit }}</div>
    <span class="dateTime">{{ date }} {{ time }} {{ weekAll[week] }}</span>
  </div>
</template>

<script>
// import { time } from 'console';

export default {
  props: {
    tit: String
  },
  data() {
    return {
      data: {},
      // weekAll: {
      //   0: "周日",
      //   1: "周一",
      //   2: "周二",
      //   3: "周三",
      //   4: "周四",
      //   5: "周五",
      //   6: "周六"
      // },
      weekAll: {
        0: "星期日",
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六"
      },
      week: "",
      date: "",
      time: ""
    };
  },

  mounted() {
    var date = new Date();
    var year = date.getFullYear(); //  返回的是年份
    var month = date.getMonth() + 1; //  返回的月份上个月的月份，记得+1才是当月
    var dates = date.getDate(); //  返回的是几号
    var day = date.getDay(); //  周一返回的是1，周六是6，但是周日是0
    var arr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    console.log("今天是" + year + "年" + month + "月" + dates + "日" + arr[day]);

    this.getDate();
  },
  methods: {
    getDate() {
      setInterval(() => {
        //获取当前时间
        let MyDate = new Date();
        //格式化为本地时间格式
        this.week = MyDate.getDay();
        let date = MyDate.toLocaleDateString();
        // this.date = date.replace(/\//g, "-");
        this.date = date;
        this.time = MyDate.toLocaleTimeString("chinese", { hour12: false });
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.haed {
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
  color: #fff;
  line-height: 84px;

  .tit_box {
    width: 1164px;
    height: 84px;
    margin: 0 auto;
    background-image: url("../../../assets/theme/one/head_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    font-size: 29px;
  }
  .tit {
    font-size: 29px;
  }
  .dateTime {
    position: absolute;
    top: 0px;
    right: 30px;
    color: #5fbbeb;
    font-size: 14px;
  }
}
</style>
